import type { Paths } from '@/__generated__/openapi-types';
import { api, SuperDutyError } from '@/api';
import { err, ok, Result } from 'neverthrow';

type LoginError =
  | { type: 'INVALID_CREDENTIALS' }
  | { type: 'API_ERROR'; error: SuperDutyError };

export const loginMutation = () => ({
  mutationFn: async (
    body: Paths.Login.RequestBody
  ): Promise<Result<Paths.Login.Responses.$200, LoginError>> => {
    try {
      const response = await api.Login({}, body);
      return ok(response.data);
    } catch (error: unknown) {
      if (error instanceof SuperDutyError) {
        if (error.code === 'INVALID_CREDENTIALS') {
          return err({ type: 'INVALID_CREDENTIALS' });
        }
      }

      return err({ type: 'API_ERROR', error: error as SuperDutyError });
    }
  },
});
